import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { FaUserClock } from "react-icons/fa";
import { GiDuration } from "react-icons/gi";
import { PiStudentBold } from "react-icons/pi";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { VscFeedback } from "react-icons/vsc";
import { motion } from "framer-motion";
import CoursesNavbar from "../components/CoursesNavbar";
import CertificateSection2 from "../components/CertificateSection2";
import GetAdmissionForm from "../components/GetAdmissionForm";
import TrainingFooter from "../components/Tranining Footer";
import AccountingFAQSection from "../components/AccountingFAQSection";
import EnrollNowButton from "../components/EnrollNowButton";
import AccountingCourseInstructors from "../components/AccountingCourseInstructors";
import Meta from "../components/Meta";

export default function AccountingCourse() {
  const [activeKey, setActiveKey] = useState("overview");
  const [modalSession, setModalSession] = useState(null);

  const courseSessions = [
    {
    title: "Session 1: Fundamentals of Accounting & Business Setup",
    topics: [
      "Types of Companies",
      "Company Legal Documents",
      "Modes of Payments",
      "Types of Vouchers & Invoices",
      "Daily Cash Flow Statement",
    ],
  },
  {
    title: "Session 2: Core Financial Transactions & Reporting",
    topics: [
      "Business Transactions",
      "Assets & Liabilities",
      "Income & Expenditure",
      "Financial Statements",
      "Adjusting Entries",
      "Closing & Opening Journal Entries",
    ],
  },
  {
    title: "Session 3: Advanced Accounting Concepts",
    topics: [
      "Bank Reconciliation",
      "Adjusting Journals",
      "Advance & Due Expenses",
      "Advance & Outstanding Income",
      "TAX & AIT (Advance Income Tax)",
      "VAT & VDS (VAT Deducted at Source)",
      "Provident Fund (PF)",
      "Depreciation and Other Adjustments",
    ],
  },
  {
    title: "Session 4: Practical Accounting – Part I",
    topics: [
      "Journal Entries",
      "Ledger Preparation",
      "Trial Balance",
      "Receipt & Payment",
      "Bank Reconciliation (Hands-on Practice)",
    ],
  },
  {
    title: "Session 5: Practical Accounting – Part II",
    topics: [
      "Receipts & Payments Statement",
      "Income Statement",
      "Financial Statement",
      "Cash Flow Statement",
      "Equity Statement",
      "Types of Capital",
    ],
  },
  {
    title: "Session 6: Taxation & Payroll Management",
    topics: [
      "Salary Sheet Preparation",
      "Yearly Salary Summary",
      "Salary Certificate",
      "Personal Tax Calculation",
      "Company Tax Calculation",
      "Tax Assessment Procedures",
      "Income Tax Certificate",
      "Revenue Schedule",
      "Bank Loan Procedure",
    ],
  },
  {
    title: "Session 7: VAT & AIT in Practice",
    topics: [
      "VAT & AIT Overview",
      "Rate of Deducted Percentage",
      "A-Challan Sample & Payment Process",
      "VAT Inclusive & Exclusive Method",
    ],
  },
  {
    title: "Session 8: VAT Return & Online Compliance (Practical)",
    topics: [
      "Mushok Forms: 6.1, 6.2, 6.3, 6.6, 6.10, 9.1",
      "New BIN Registration Process",
      "Online VAT Return Submission",
    ],
  },
  {
    title: "Session 9: Tally ERP Software Training",
    topics: [
      "Introduction to Tally ERP",
      "Chart of Accounts",
      "Cost Centre Break-up",
      "Financial Statement Preparation",
      "Report Generation",
      "Data Entry & Practical Exercises",
    ],
  },
  {
    title: "Session 10: Cost & Management Accounting",
    topics: [
      "Cost Sheet Preparation",
      "Stock Management",
      "Fixed Asset Register",
      "Fixed & Variable Costs",
      "Break-Even Point (BEP) Analysis",
      "Management Report Preparation",
      "Tax-Based vs. Management Accounts",
    ],
  },
  {
    title: "Session 11: Corporate Readiness & Final Discussion",
    topics: [
      "Corporate Behavior & Professional Ethics",
      "Review of Key Topics",
      "Frequently Asked Questions (FAQ)",
      "Certification Guidelines",
    ],
  },
];
<Meta title="Schedule X Return Filing in Bangladesh | RJSC Return Filing"
          description="Schedule X Return Filing in Bangladesh. A limited company required schedule X filled each financial year to the authority (RJSC)"
          keywords="Schedule X Return, Schedule X,  Schedule X in Bangladesh, RJSC Return Filing, company office return file, RJSC Return Filing in Bangladesh"
      />
  const courseFacts = [
    { icon: <PiStudentBold />, text: "Total Classes", value: "10+" },
    { icon: <FaUserClock />, text: "Time", value: "8:00 PM – 10:00 PM" },
    { icon: <GiDuration />, text: "Duration", value: "2 Hours+" },
    { icon: <RiCalendarScheduleFill />, text: "Days", value: "Friday & Saturday" },
    { icon: <VscFeedback />, text: "Fee", value: "৳6000" },
  ];

  const openModal = (session) => setModalSession(session);
  const closeModal = () => setModalSession(null);

  const sessionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <CoursesNavbar />
      {/* Hero Section */}
      <div style={{
        background: "linear-gradient(to right, #0066cc, #3399ff)",
        padding: "100px 20px",
        color: "#fff",
        textAlign: "center",
      }}>
        <h1 style={{ fontSize: "38px", fontWeight: "bold" }}>Professional Accounting Certificate Course</h1>
        <p style={{ fontSize: "18px", marginTop: "10px" }}>
          A comprehensive course designed for aspiring accounting professionals.
        </p>
      </div>

      {/* Card Section with Tabs */}
      <div style={{
        backgroundColor: "#fff",
        maxWidth: "1000px",
        margin: "-80px auto 40px",
        borderRadius: "20px",
        padding: "40px 30px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
      }}>
        <h2 style={{ fontSize: "24px", marginBottom: "20px" }}>Course Overview</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.7" }}>
          This certificate course is jointly organized by JK Associates and Chartered Skills. The training will be held on the premises of JK Associates.
        </p>

        <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k || "overview")} style={{ marginTop: "30px" }}>
          <Tab eventKey="overview" title="Overview">
            <p style={{ marginTop: "20px", fontSize: "15px", lineHeight: "1.7" }}>
              The Professional Accounting Certificate Course by JK Associates is a comprehensive, career-focused training program designed to build strong foundations in modern accounting, taxation, and financial management practices. This program equips learners with both theoretical knowledge and hands-on practical skills needed to work confidently in real-world business and corporate environments.

Throughout 11 detailed sessions, participants will learn about company structure, financial documentation, business transactions, taxation (VAT, AIT, and income tax), payroll management, bank reconciliation, and financial statement preparation. The course also includes practical sessions on Tally ERP software, VAT return submission, and financial reporting, ensuring learners gain complete accounting proficiency.

In addition, participants will develop essential skills in cost management, tax assessment, and corporate behavior, preparing them to perform effectively in any professional accounting role. Upon successful completion, learners receive a recognized professional certificate from JK Associates, enhancing their career opportunities in accounting, finance, and business administration.
            </p>
          </Tab>

          <Tab eventKey="outline" title="Outline">
            <motion.div
              style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "20px" }}
              initial="hidden"
              animate="visible"
              variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
            >
              {courseSessions.map((session, idx) => (
                <motion.div
                  key={idx}
                  style={{
                    flex: "1 1 45%",
                    backgroundColor: "#3399ff", // changed to blue
                    color: "#fff",
                    borderRadius: "15px",
                    padding: "20px",
                    cursor: "pointer",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
                    textAlign: "center"
                  }}
                  variants={sessionVariants}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => openModal(session)}
                >
                  <h5 style={{ fontWeight: "600" }}>{session.title}</h5>
                  <p>Click to view details</p>
                </motion.div>
              ))}
            </motion.div>
          </Tab>
        </Tabs>
      </div>

      {/* Course Facts Section */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "25px",
        padding: "30px 20px",
      }}>
        {courseFacts.map((item, i) => (
          <motion.div
            key={i}
            style={{
              backgroundColor: "#3399ff", // changed to blue
              color: "#fff",
              borderRadius: "15px",
              width: "200px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
            whileHover={{ scale: 1.05 }}
          >
            <div style={{ fontSize: "28px", marginBottom: "10px" }}>{item.icon}</div>
            <h4 style={{ fontSize: "16px" }}>{item.text}</h4>
            <p style={{ fontSize: "14px" }}>{item.value}</p>
          </motion.div>
        ))}
      </div>

      {/* Modal Popup for Session Details */}
      {modalSession && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex", justifyContent: "center", alignItems: "center",
          zIndex: 9999
        }} onClick={closeModal}>
          <motion.div
            style={{
              backgroundColor: "#3399ff", // changed to blue
              color: "#fff",
              borderRadius: "15px",
              padding: "30px",
              maxWidth: "600px",
              width: "90%",
              maxHeight: "80%",
              overflowY: "auto"
            }}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ marginBottom: "15px" }}>{modalSession.title}</h3>
            <ul style={{ paddingLeft: "20px" }}>
              {modalSession.topics.map((topic, idx) => (
                <li key={idx} style={{ marginBottom: "10px" }}>{topic}</li>
              ))}
            </ul>
            <button
              onClick={closeModal}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                border: "none",
                color: "#fff",
                borderRadius: "10px",
                cursor: "pointer"
              }}
            >
              Close
            </button>
          </motion.div>
        </div>
        
      )}
      <EnrollNowButton />
      <CertificateSection2 />
      {/* Instructors */}
      <AccountingCourseInstructors/>
      <AccountingFAQSection/>
      <GetAdmissionForm />
      <TrainingFooter />

    </>
  );
}
